import { RouterConfigItem } from 'portal/routes/types'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import routeConfigs from './RouteGroups'

export default function routes() {
  return (
    <Switch>
      {routeConfigs.map(renderNormalRoute)}
      <Redirect to='/' />
    </Switch>
  )
}

/**
 * 渲染路由组件
 */
const renderNormalRoute = (item: RouterConfigItem, index: number) => {
  return (
    <Route
      exact
      key={index}
      path={item.path}
      render={item.render}
      component={item.component}
    />
  )
}
